import React, { Component } from 'react';
import Opportunity from './OpportunityComponent';
import Loading from './LoadingComponent';
// import Footer from './FooterComponent';
import Navigator from './NavigatorComponent';

import OpportunityActions from 'actions/OpportunityActions';
import OpportunityStore from 'stores/OpportunityStore';

require('styles/Opportunities.scss');

class OpportunitiesComponent extends Component{
  constructor(props) {
    super(props);
    let opportunityStore = OpportunityStore.getState();
    this.state = {
      hasMore: opportunityStore.hasMore,
      loading: opportunityStore.loading,
      opportunityList: opportunityStore.opportunityList,
      fetchTimeOut: null,
      showNavigator: false
    };
    this.onOpportunityChange = this.onOpportunityChange.bind(this);
    this.onOpportunityScroll = this.onOpportunityScroll.bind(this);
    this.loadMore = this.loadMore.bind(this)
  }
  componentDidMount(){
    let opportunityStore = OpportunityStore.getState();
    window.scrollTo(0, opportunityStore.offset);
    OpportunityStore.listen(this.onOpportunityChange);
    if(this.state.opportunityList.length === 0) {
      OpportunityActions.fetchOpportunityList();
    }
    window.addEventListener('scroll',this.onOpportunityScroll);
    window.changeMetaForSEO(false);
    window._hmt.push(['_trackPageview', this.props.location.pathname]);
  }
  componentWillUnmount(){
    OpportunityActions.updateOpportunityOffset($(document).scrollTop());
    OpportunityStore.unlisten(this.onOpportunityChange);
    window.removeEventListener('scroll',this.onOpportunityScroll);
  }
  onOpportunityChange(opportunity){
    this.setState({
      opportunityList: opportunity.opportunityList,
      loading: opportunity.loading,
      hasMore: opportunity.hasMore
    });
  }
  onOpportunityScroll(event) {
    if(this.state.fetchTimeOut) {
      clearTimeout(this.state.fetchTimeOut);
    }
    let scrollTop = $(document).scrollTop();
    let clientHeight = event.srcElement.body.clientHeight;
    let scrollHeight = event.srcElement.body.scrollHeight;
    if(scrollTop + clientHeight === scrollHeight) {
      OpportunityActions.setLoading(true);
      this.setState({fetchTimeOut: setTimeout(OpportunityActions.fetchOpportunityList, 1000)});
    }
    if(scrollTop > 500){
      this.setState({showNavigator:true});
    }else{
      this.setState({showNavigator:false});
    }
  }
  loadMore() {
    OpportunityActions.setLoading(true);
    OpportunityActions.fetchOpportunityList()
  }
  render(){
    let rows = new Array();
    this.state.opportunityList.forEach(function(opportunity) {
      rows.push(<Opportunity opportunity={opportunity} key={opportunity._id} />);
    });
    let navigator;
    if(this.state.showNavigator){
      navigator = <Navigator action='top' />
    }
    return (
      <div className="opportunities-component">
        {rows}
        <Loading 
          loading={this.state.loading} 
          hasMore={this.state.hasMore} 
          loadMore={this.loadMore} />
        <Navigator action='home' number={3} />
        <Navigator action='left' number={2} />
        {navigator}
      </div>
    );
  }
}

export default OpportunitiesComponent;




// WEBPACK FOOTER //
// ./src/components/OpportunitiesComponent.js